import { i18n } from "@/i18n";
import { analyticsTagsConstantes } from "@/constantes/analyticsTags";

export default {
  path: "/studea-manager/indent-sheet",
  name: "studeaManagerIndentSheet",
  component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutWithErrorView.vue"),
  meta: {
    authRequired: true,
    title: i18n.global.tc("studea_manager.incident_sheet.title", 1),
    breadcrumb: true,
  },
  children: [
    {
      path: "list",
      name: "studeaManagerIncidentSheetList",
      component: () =>
        import(
          /* webpackChunkName: "studea-manager" */ "@/views/StudeaManager/IncidentSheet/IncidentSheetListView.vue"
        ),
      meta: {
        title: i18n.global.t("studea_manager.incident_sheet.list"),
        breadcrumb: true,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_DASHBOARD_VIGILANCE_SHEETS,
      },
    },
  ],
};
